module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"message":"Mudando perfil..."},"en-US":{"message":"Switching profile..."}}')
  delete Component.options._Ctor
}
